export { useFetchAdPrices } from './useFetchAdPrices';
